import React, { useState } from 'react';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { ref, set } from 'firebase/database';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { auth, db } from '../firebase';
import img from '../images/breathlogo.png';
import '../styling/login.css';

const doctorRegistrationKey = process.env.REACT_APP_DOCTOR_REGISTRATION_KEY;

function Register() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [attestationNumber, setAttestationNumber] = useState('');
  const [registrationKey, setRegistrationKey] = useState('');
  const [registrationError, setRegistrationError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleRegister = async () => {
    setRegistrationError('');

    if (!name || !email || !password || !attestationNumber || !registrationKey) {
      setRegistrationError('Vyplňte prosím všetky povinné polia.');
      return;
    }

    if (!doctorRegistrationKey) {
      setRegistrationError('Registrácia lekárov nie je nakonfigurovaná. Chýba registračný kľúč aplikácie.');
      return;
    }

    if (registrationKey !== doctorRegistrationKey) {
      setRegistrationError('Registračný kľúč nie je správny.');
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await createUserWithEmailAndPassword(auth, email, password);
      const doctorRef = ref(db, `doctors/${response.user.uid}`);

      await set(doctorRef, {
        id: response.user.uid,
        name,
        email,
        attestationNumber,
        registeredAt: new Date().toISOString(),
      });

      toast.success('Registrácia lekára prebehla úspešne.');
      navigate('/mainpage');
    } catch (error) {
      console.error('Error registering doctor:', error);
      if (error.code === 'auth/email-already-in-use') {
        setRegistrationError('Táto emailová adresa je už zaregistrovaná.');
      } else if (error.code === 'auth/weak-password') {
        setRegistrationError('Heslo musí mať aspoň 6 znakov.');
      } else if (error.code === 'auth/invalid-email') {
        setRegistrationError('Emailová adresa nie je platná.');
      } else {
        setRegistrationError('Registrácia zlyhala. Skúste to prosím znova.');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="centering">
      <div className="login-container">
        <img className="image" src={img} alt="Logo" />
        <h2 className="login-title">Registrácia lekára</h2>
        <form>
          <label htmlFor="name" className="login-label">Meno a priezvisko:</label>
          <input
            type="text"
            id="name"
            className="login-input"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />

          <label htmlFor="email" className="login-label">Emailová adresa:</label>
          <input
            type="email"
            id="email"
            className="login-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <label htmlFor="password" className="login-label">Heslo:</label>
          <input
            type="password"
            id="password"
            className="login-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <label htmlFor="attestationNumber" className="login-label">Číslo atestácie:</label>
          <input
            type="text"
            id="attestationNumber"
            className="login-input"
            value={attestationNumber}
            onChange={(e) => setAttestationNumber(e.target.value)}
          />

          <label htmlFor="registrationKey" className="login-label">Registračný kľúč:</label>
          <input
            type="password"
            id="registrationKey"
            className="login-input"
            value={registrationKey}
            onChange={(e) => setRegistrationKey(e.target.value)}
          />

          {registrationError && <p className="login-error">{registrationError}</p>}

          <button type="button" onClick={handleRegister} className="login-button" disabled={isSubmitting}>
            {isSubmitting ? 'Registrujem...' : 'Zaregistrovať sa'}
          </button>

          <button type="button" onClick={() => navigate('/')} className="secondary-button">
            Späť na prihlásenie
          </button>
        </form>
      </div>
    </div>
  );
}

export default Register;
